import React, { FC, useState, useEffect } from 'react';
import { language, link_ua, link_ru } from '../../components/locale/config';
import {
  StyledHeader,
  HeaderContainer,
  LogoContainer,
  Logo,
  LanguageButton,
} from './styled';
import { Share } from './share';
import { HeaderMenu } from '../header_menu';

type Props = {
  isHeaderMenuOpen: boolean;
  timelineAnchor: number;
  handleLeft: () => void;
  handleRight: () => void;
};
export const Header: FC<Props> = ({
  isHeaderMenuOpen,
  timelineAnchor,
  handleLeft,
  handleRight,
}) => {
  const [isShareOpen, setIsShareOpen] = useState(false);
  const toggleShare = () => setIsShareOpen((v) => !v);

  const [y, setY] = useState(0);
  const [isHeaderOpen, setIsHeaderOpen] = useState(true);
  //const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);

  const ukrainianLink = link_ua;
  const russianLink = link_ru;

  const handleNavigation = (e: any) => {
    const window = e.currentTarget;
    if (y > window.scrollY) {
      setIsHeaderOpen(true);
    } else if (y < window.scrollY - 40 && window.scrollY > 100) {
      setIsHeaderOpen(false);
    }

    setY(window.scrollY);
  };

  useEffect(() => {
    setY(window.scrollY);

    window.addEventListener('scroll', (e: any) => handleNavigation(e));
  }, [y]);

  return (
    <>
      <StyledHeader $isHeaderOpen={isHeaderOpen}>
        <HeaderMenu
          isOpen={isHeaderMenuOpen}
          timelineAnchor={timelineAnchor}
          handleLeft={() => handleLeft()}
          handleRight={() => handleRight()}
        />
        <HeaderContainer>
          <div className="header-background"></div>
          <LogoContainer href="/">
            <Logo />
          </LogoContainer>
          <div>
            <LanguageButton $isOpen={isShareOpen}>
              {language === 'ua' ? (
                <a className="passive">УК &nbsp;</a>
              ) : (
                <a className="active" href={ukrainianLink}>
                  УК&nbsp;
                </a>
              )}
              /
              {language === 'ru' ? (
                <a className="passive">&nbsp; РУ</a>
              ) : (
                <a className="active" href={russianLink}>
                  &nbsp;РУ
                </a>
              )}
            </LanguageButton>
            <Share isOpen={isShareOpen} onToggle={toggleShare} />
          </div>
        </HeaderContainer>
      </StyledHeader>
    </>
  );
};
